import publisherAPIInstance from "./publisherApiInstance";

export const ftpPublishAPIs = {
  ftpPublish: ({ payload }) => publisherAPIInstance.post(`/api/v1/ftp.publish`, payload),
  getFtpList: ({ payload }) => publisherAPIInstance.post(`/api/v1/ftp.list`, payload),
  createFtpCredentials: ({ payload }) => publisherAPIInstance.post(`/api/v1/ftp.create`, payload),
  updateFtpCredentials: ({ payload }) => publisherAPIInstance.post(`/api/v1/ftp.update`, payload),
  deleteFtpCredentials: ({ payload }) => publisherAPIInstance.post(`/api/v1/ftp.delete`, payload),
};
